import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';

interface AttributeCellProps {
	value: string | number | null | undefined;
}

// Pipe attribute (material, installation year). Missing values are a muted
// dash, matching the driver columns, never "null" or blank. role="img" so
// screen readers announce the label (aria-label is ignored on a bare span).
export const AttributeCell = ({ value }: AttributeCellProps) => {
	const { t } = useGlobalization();
	if (value === null || value === undefined || value === '') {
		return (
			<span
				data-testid="attribute-missing"
				role="img"
				aria-label={t('No value')}
				style={{ color: '#6b7280' }}>
				—
			</span>
		);
	}
	return <span>{String(value)}</span>;
};
